import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";
import { IdService } from "../../shared/services/id.service";

@Component({
	selector: "rbc-link-card-container",
	templateUrl: "./link-card-container.component.html",
	encapsulation: ViewEncapsulation.None
})
export class LinkCardContainerComponent implements OnInit {
	@Input() id: string;
	@Input() title: string;
	@Input() items: [];
	@Input() columns: string;
	@Input() layout = "card";


	get getLayout() {
		return this.layout;
	}

	get getColumns() {
		return this.columns;
	}

	constructor(private idService: IdService) {}

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	cardClassGen() {
		const { layout, columns } = this;
		if (layout !== "card") {
			return;
		}
		return {
			"card-col-my": true,
			"col-xl-3": columns === "4",
			"col-md-4": columns === "4" || columns === "3",
			"col-sm-6": columns === "4" || columns === "3" || columns === "2"
		};
	}
}
